import script from "./ObrasOSViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ObrasOSViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ObrasOSViewPage.vue?vue&type=style&index=0&id=462dc74c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462dc74c"]])

export default __exports__